// store/middleware/favoritesCacheMiddleware.ts
import { Middleware } from "@reduxjs/toolkit";
import { saveToStorage } from "../../common/utils/functions/localStorage";
import { selectAllFavorites } from "../slices/favoritesSlice";
import { getCacheVersion } from "../../config/runtimeConfig";

const FAVORITES_ACTIONS = [
  "favorites/setFavorites",
  "favorites/addMoreFavorites",
  "favorites/updateFavoriteItem",
  "favorites/removeFavoriteItem",
  "favorites/addFavoriteItem",
  "favorites/clearFavorites",
];

export const favoritesCacheMiddleware: Middleware =
  (store) => (next) => (action: any) => {
    const result = next(action);

    if (action.type && FAVORITES_ACTIONS.includes(action.type)) {
      const state = store.getState();
      const items = selectAllFavorites(state);
      const total = state.favorites.total;

      const cacheData = {
        data: items,
        total: total || items.length,
      };

      try {
        const version = getCacheVersion();
        const CACHE_KEY = `favorites_v${version}`;
        saveToStorage(CACHE_KEY, cacheData);
      } catch (error) {
        console.error("Ошибка сохранения кэша избранного:", error);
      }
    }

    return result;
  };
